





















import { computed, defineComponent, PropType, provide } from '@nuxtjs/composition-api';
import useFeatureFlag from '@shared/composables/useFeatureFlag';
import useToggleState from '@shared/composables/useToggleState';
import { UCAppHeader } from '@shared/ui';
import { useUser } from '@unified-commerce/gpc-vue-storefront-shopify';

import { Dropdown } from '~/components/AppHeader/constants';
import HeaderAccount from '~/components/AppHeader/HeaderAccount.vue';
import HeaderCart from '~/components/AppHeader/HeaderCart.vue';
import HeaderGarage from '~/components/AppHeader/HeaderGarage.vue';
import HeaderLogo from '~/components/AppHeader/HeaderLogo.vue';
import HeaderStore from '~/components/AppHeader/HeaderStore.vue';

import NavigationMenu from '../CMS/NavigationMenu/NavigationMenu.vue';
import { INavigationMenuItem } from '../CMS/NavigationMenuItem/NavigationMenuItem.vue';
import SearchBar from '../SearchBar/SearchBar.vue';

export default defineComponent({
  name: 'AppHeader',
  components: {
    UCAppHeader,
    HeaderLogo,
    HeaderAccount,
    HeaderStore,
    HeaderCart,
    HeaderGarage,
    NavigationMenu,
    SearchBar,
  },
  props: {
    navigationMenuItems: {
      type: Array as PropType<INavigationMenuItem[]>,
      default: () => [],
    },
    searchResult: {
      type: [Object, Array],
      default: null,
    },
    searchResultLoading: {
      type: Boolean,
      required: true,
    },
    brands: {
      type: Array,
      required: true,
    },
    sortedASKUs: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const { state: garageDropdownOpen } = useToggleState(Dropdown.Garage);
    const { state: accountDropdownOpen } = useToggleState(Dropdown.Account);
    const { user } = useUser();
    const { isFeatureEnabled } = useFeatureFlag();

    const isAuthenticated = computed(() => !!user.value?.token);

    provide(
      'searchResult',
      computed(() => props.searchResult),
    );
    provide(
      'searchResultLoading',
      computed(() => props.searchResultLoading),
    );
    provide(
      'brands',
      computed(() => props.brands),
    );
    provide(
      'sortedASKUs',
      computed(() => props.sortedASKUs),
    );

    const showOverlay = computed(() => garageDropdownOpen.value || accountDropdownOpen.value);

    return { isAuthenticated, isFeatureEnabled, showOverlay };
  },
});
